import { Config } from '@/types/config';
import errorTpl from '@/templates/error.tpl';

export function parseTpl (appConfig: Config, template: string) {
    if (appConfig.xmlParser) {
        let result = new DOMParser().parseFromString(`<template>${template}</template>`, 'text/xml');
        if (result.querySelector('parsererror')) {
            let error = result.querySelector('parsererror > div')?.innerHTML;
            console.error(error, '@', template);

            if (!window.__odrKangaroo) {
                return new DOMParser().parseFromString('<template></template>', 'text/xml');
            } else {
                return new DOMParser().parseFromString(`<template>${errorTpl({ error, template })}</template>`, 'text/xml');
            }
        }
        return result;
    } else {
        let container = document.createElement('div');
        container.innerHTML = template;
        return container;
    }
}

export function serializeTpl (appConfig: Config, container: Document | HTMLElement) {
    if (appConfig.xmlParser) {
        return new XMLSerializer().serializeToString(container);
    } else {
        return (container as HTMLElement).innerHTML;
    }
}

export function addParamToTpl (appConfig: Config, template: string, selector: string, attribute: string, value: string) {
    if (appConfig.xmlParser) {
        let xmlDoc = parseTpl(appConfig, template);
        let changeNodes = xmlDoc.querySelectorAll(selector);

        if (changeNodes.length) {
            Array.from(changeNodes).forEach(node => {
                node.setAttribute(attribute, value);
            });
        }
        return serializeTpl(appConfig, xmlDoc);
    } else {
        let container = document.createElement('div');
        container.innerHTML = template;
        let changeNodes = container.querySelectorAll(selector);

        if (changeNodes.length) {
            Array.from(changeNodes).forEach(node => {
                node.setAttribute(attribute, value);
            });
        }

        return container.innerHTML;
    }
}
